import { render } from "./AdministratorUserContent.vue?vue&type=template&id=3bbc6103"
import script from "./AdministratorUserContent.vue?vue&type=script&lang=js"
export * from "./AdministratorUserContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__